import React, { useEffect, useRef } from 'react'

import { ButtonBase } from '@material-ui/core'
import { MAP_ID } from '../../utils/apiHelper'
import { useMapEngine } from '../shared'

export const FocusControl = ({ Icon, center, zoom }) => {
  const [engine] = useMapEngine(MAP_ID)
  const refMenu = useRef(null)
  const controlGroup = document.querySelector(
    '.mapboxgl-ctrl-top-left .mapboxgl-ctrl-group'
  )
  useEffect(() => {
    if (controlGroup) {
      controlGroup.appendChild(refMenu.current)
    }
  }, [refMenu, controlGroup])

  const handleMeasure = () => {
    engine.flyTo({ center, zoom })
  }

  return (
    <ButtonBase ref={refMenu} onClick={handleMeasure}>
      <Icon />
    </ButtonBase>
  )
}
